import React, { useState } from "react";
import ReservationList from "./ReservationList";
import ReservationMobileList from "./ReservationMobileList";
import ReservationForm from "./ReservationForm";
import { useSelector, useDispatch } from "react-redux";
import GlobalPopup from "../../component/Popup/GlobalPopup.js";
import { openGlobalPopup } from "../../redux/action";
import { useIsMobile } from "../../component/Hooks/useIsMobile.js";

function ReservationsPage() {
  const [action, setAction] = useState(null);
  const edit = useSelector((state) => state?.admin?.edit);
  const reservationSaving = useSelector((state) => Boolean(state?.admin?.reservationSaving));
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const closePopUp = () => {
    dispatch({ type: 'EDIT_RESERVATION', payload: null });
    setAction(null);
  }

 const addReservation = () => {
    dispatch({ type: 'EDIT_RESERVATION', payload: null });
    setAction("add-reservation");
    dispatch(openGlobalPopup("add-reservation"));
  }
  const editReservation = () => {
    setAction("edit-reservation");
    dispatch(openGlobalPopup("edit-reservation"));
  };

  return (
    <div className="container">
      <h1>Manage Reservations</h1>

      <button
        className="add-button ui-page-add-button"
        onClick={() => { addReservation(); }}
      >
        Add Reservation
      </button>


      <GlobalPopup
        popupKey={action}
        title={edit?.reservationId ? 'Edit Reservation' : 'Add New Reservation'}
        onClose={closePopUp}
        disableClose={reservationSaving}
        footer={(closePopup) => (
          <>
            <button type="button" className="popup-action-btn secondary" onClick={closePopup} disabled={reservationSaving}>Cancel</button>
            <button type="submit" form="reservation-form" className="popup-action-btn" disabled={reservationSaving} aria-busy={reservationSaving}>
              {reservationSaving ? <><span className="popup-button-spinner" aria-hidden="true" />Saving...</> : edit?.reservationId ? 'Edit Reservation' : 'Add Reservation'}
            </button>
          </>
        )}
      >
        <ReservationForm edit={edit?.reservationId ? edit : undefined} />
      </GlobalPopup>

      <section className="list-section">
        {isMobile ? (
          <ReservationMobileList onEdit={editReservation} />
        ) : (
          <ReservationList onEdit={editReservation} />
        )}
      </section>
    </div>
  );
}

export default ReservationsPage;
